/**
 * Single-location salon: one primary outlet holds billing address for receipts/reports.
 */

export function resolvePrimaryOutlet(outlets, preferredId) {
    if (!outlets?.length) return null;
    if (preferredId) {
        const match = outlets.find((o) => o.id === preferredId);
        if (match) return match;
    }
    return outlets[0];
}

export function primaryOutletIndex(outlets, preferredId) {
    if (!outlets?.length) return -1;
    if (preferredId) {
        const idx = outlets.findIndex((o) => o.id === preferredId);
        if (idx >= 0) return idx;
    }
    return 0;
}

/** Header block for printed receipts and revenue reports. */
export function businessHeader(outlets, user, outletId) {
    const outlet = resolvePrimaryOutlet(outlets, outletId || user?.outlet_id);
    return {
        name: user?.tenant_name || outlet?.name || "Salon & Spa",
        address: outlet?.address,
        city: outlet?.city,
        phone: outlet?.phone,
        gstin: outlet?.gstin,
    };
}
